import { render, staticRenderFns } from "./FieldBorderList.vue?vue&type=template&id=2c3e4baf&scoped=true&lang=html&"
import script from "./FieldBorderList.vue?vue&type=script&lang=js&"
export * from "./FieldBorderList.vue?vue&type=script&lang=js&"
import style0 from "./FieldBorderList.vue?vue&type=style&index=0&id=2c3e4baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e4baf",
  null
  
)

export default component.exports